import { ConfiguratorRenewalInformation } from '@models';
import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './renewal.actions';

export interface State {
  renewalInformation: ConfiguratorRenewalInformation;
}

export const featureKey = 'flowDataRenewal';

export const initialState: State = {
  renewalInformation: {},
};

export function renewalReducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(Actions.UpdateFlowRenewalInformation, (state, { data }) => ({ ...state, renewalInformation: data }))
  )(state, action);
}
